"use client";
import { useEffect } from "react";
import { castService } from "~/services/cast.service";


export default function CastBridge() {
  useEffect(() => {
    // SDK loading is deferred until the first playSong() call via
    // castService.loadSdk(). CastBridge only handles cleanup on unmount.
    return () => {
      castService.dispose();
    };
  }, []);

  return null;
}
